<div [@routerTransition]>
    <sub-header [title]="this.headerText" [description]="this.description">
        <div role="actions">
            <button id="btn_create_SalesNotes" *ngIf="'Pages.SalesNotes.Create' | permission"
                    (click)="createSalesNotes()" class="btn btn-primary blue">
                <i class="fa fa-plus"></i>
                {{ this.headerText }}
            </button>
        </div>
    </sub-header>

    <div [class]="containerClass">
        <div class="card card-custom gutter-b">
            <div class="card-body">
                <form class="form" autocomplete="off">
                    <div>
                        <div class="row align-items-center">
                            <div class="col-xl-12">
                                <div class="my-3">
                                    <div class="input-group mb-3">
                                        <input [(ngModel)]="filterText" (ngModelChange)="getSalesNotes()"
                                            name="filterText" autoFocus type="text" class="form-control"
                                            [placeholder]="l('SearchWithThreeDot')" />
                                        <button class="btn btn-primary" type="submit" (click)="getSalesNotes()">
                                            <i class="flaticon-search-1"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row" [hidden]="!advancedFiltersAreShown">
                            <div class="col-md-12"></div>

                            <div class="col-md-3">
                                <div class="my-3">
                                    <label class="form-label" for="VendorDisplayPropertyFilter">
                                        {{ l('Customer') }}
                                    </label>
                                    <input type="text" class="form-control" id="referenceNo"
                                           name="referenceNo" [(ngModel)]="referenceNo" />
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="my-3">
                                    <label class="form-label" for="VendorDisplayPropertyFilter">
                                        {{ l('TransactionNo') }}
                                    </label>
                                    <input type="text" class="form-control" id="transactionNo"
                                           name="transactionNo" [(ngModel)]="transactionNo" />
                                </div>
                            </div>

                            <div class="col-md-12 mt-5">
                                <button (click)="resetFilters()" class="btn btn-secondary btn-sm"
                                        id="btn-reset-filters">
                                    Reset
                                </button>
                            </div>
                        </div>
                        <div class="row my-4">
                            <div class="col-sm-12">
                                <span class="clickable-item text-muted" *ngIf="!advancedFiltersAreShown"
                                    (click)="advancedFiltersAreShown = !advancedFiltersAreShown">
                                    <i class="fa fa-angle-down"></i>
                                    {{ l('ShowAdvancedFilters') }}
                                </span>

                                <span class="clickable-item text-muted" *ngIf="advancedFiltersAreShown"
                                    (click)="advancedFiltersAreShown = !advancedFiltersAreShown">
                                    <i class="fa fa-angle-up"></i>
                                    {{ l('HideAdvancedFilters') }}
                                </span>
                            </div>
                        </div>
                    </div>
                </form>

                <div class="row align-items-center">
                    <!--<Primeng-Datatable-Start>-->
                    <div class="primeng-datatable-container col-12" [busyIf]="primengTableHelper.isLoading">
                        <p-table #dataTable (onLazyLoad)="getSalesNotes($event)"
                            [value]="primengTableHelper.records"
                            rows="{{ primengTableHelper.defaultRecordsCountPerPage }}" [paginator]="false"
                            tableStyleClass="table table-bordered table-hover" [lazy]="true" [scrollable]="true"
                            ScrollWidth="100%" [tableStyle]="{ 'min-width': '50rem' }"
                            [resizableColumns]="primengTableHelper.resizableColumns">
                            <ng-template pTemplate="header">
                                <tr>
                                    <th style="width: 5%" [hidden]="
                                            !isGrantedAny('Pages.SalesNotes.Edit', 'Pages.SalesNotes.Delete')
                                        ">
                                        {{ l('Actions') }}
                                    </th>
                                    <th style="width: 150px" pSortableColumn="pNo">
                                        {{ l('InvoiceNo') }}
                                        <p-sortIcon field="SalesNotes.pNo"></p-sortIcon>
                                    </th>
                                    <th style="width: 150px" pSortableColumn="pDate">
                                        {{ l('PDate') }}
                                        <p-sortIcon field="SalesNotes.pDate"></p-sortIcon>
                                    </th>
                                    <th style="width: 150px" pSortableColumn="vendorFk.displayProperty">
                                        {{ l('Vendor') }}
                                        <p-sortIcon field="vendorDisplayProperty"></p-sortIcon>
                                    </th>

                                    <th style="width: 150px" pSortableColumn="referenceNo">
                                        {{ l('ReferenceNo') }}
                                        <p-sortIcon field="SalesNotes.referenceNo"></p-sortIcon>
                                    </th>
                                    <th style="width: 150px" pSortableColumn="subTotal">
                                        {{ l('PSubTotal') }}
                                        <p-sortIcon field="SalesNotes.subTotal"></p-sortIcon>
                                    </th>
                                    <th style="width: 150px" pSortableColumn="tax">
                                        {{ l('PTax') }}
                                        <p-sortIcon field="SalesNotes.tax"></p-sortIcon>
                                    </th>
                                    <th style="width: 150px" pSortableColumn="netTotal">
                                        {{ l('PNetTotal') }}
                                        <p-sortIcon field="SalesNotes.netTotal"></p-sortIcon>
                                    </th>
                                   
                                    <th style="width: 150px" pSortableColumn="status">
                                        <b>{{ l('Status') }}</b>
                                        <p-sortIcon field="SalesNotes.status"></p-sortIcon>
                                    </th>
                                    <th style="width: 150px" pSortableColumn="paymentStatus" *ngIf="this.type != 3">
                                        <b>{{ l('PaymentStatus') }}</b>
                                        <p-sortIcon field="SalesNotes.status"></p-sortIcon>
                                    </th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-record="$implicit" let-i="rowIndex">
                                <tr>
                                    <td style="width: 5%" [hidden]="
                                            !isGrantedAny('Pages.SalesNotes.Edit', 'Pages.SalesNotes.Delete')
                                        ">
                                        <div class="btn-group dropdown" dropdown container="body">
                                            <button class="dropdown-toggle btn btn-sm btn-primary" dropdownToggle>
                                                <i class="fa fa-cog"></i>
                                                <span class="caret"></span>
                                            </button>
                                            <ul class="dropdown-menu" *dropdownMenu>
                                                <li>
                                                    <a *ngIf="permission.isGranted('Pages.SalesNotes.Edit') && record.salesNotes.status == status.Returned"
                                                       class="dropdown-item"
                                                       [routerLink]="[
                                                            '/app/account/salesNotes/createOrEdit',
                                                        ]"
                                                       [queryParams]="{ id: record.salesNotes.id }">
                                                        {{ l('View') }}
                                                    </a>
                                                </li>
                                                <li>
                                                    <a *ngIf="permission.isGranted('Pages.SalesNotes.Edit') && record.salesNotes.status == status.Draft"
                                                       class="dropdown-item"
                                                       [routerLink]="[
                                                            '/app/account/salesNotes/createOrEdit',
                                                        ]"
                                                       [queryParams]="{ id: record.salesNotes.id , type:  this.type }">
                                                        {{ l('Edit') }}
                                                    </a>
                                                </li>
                                                <li>
                                                    <a class="dropdown-item"
                                                       href="javascript:;"
                                                       *ngIf="permission.isGranted('Pages.SalesNotes.Draft') && record.salesNotes.status == status.Invoiced && record.salesNotes.paymentStatus == paymentStatus.UnPaid"
                                                       (click)="convertToDraft(record.salesNotes)">
                                                        {{ l('ConvertToDraft') }}
                                                    </a>
                                                </li>
                                                <li>
                                                    <a class="dropdown-item"
                                                       href="javascript:;"
                                                       *ngIf="permission.isGranted('Pages.SalesNotes.Invoiced') && record.salesNotes.status == status.Draft && record.salesNotes.paymentStatus == paymentStatus.UnPaid"
                                                       (click)="convertToInvoice(record.salesNotes)">
                                                        {{ l('ConvertToInvoiced') }}
                                                    </a>
                                                </li>
<!--                                                 <li>
                                                    <a *ngIf="record.salesNotes.paymentStatus == paymentStatus.UnPaid"
                                                       class="dropdown-item"
                                                       [routerLink]="[
                                                            '/app/purchase/vendorPayments/createOrEdit',
                                                        ]"
                                                       [queryParams]="{ vid: record.salesNotes.vendorId, invid: record.purchase.id }">
                                                        {{ l('Pay') }}
                                                    </a>
                                                </li> -->
                                                <li>
                                                    <a class="dropdown-item"
                                                       href="javascript:;"
                                                       *ngIf="permission.isGranted('Pages.SalesNotes.Delete') &&  record.salesNotes.paymentStatus == paymentStatus.UnPaid"
                                                       (click)="deleteSalesNotes(record.salesNotes)">
                                                        {{ l('Delete') }}
                                                    </a>
                                                </li>
                                                <li>
                                                    <a class="dropdown-item"
                                                       href="javascript:;"
                                                       (click)="print(record.salesNotes.id)">
                                                        {{ l('Print') }}
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </td>
                                    <td style="width: 150px">
                                        <span class="p-column-title">{{ l('InvoiceNo') }}</span>
                                        {{ record.salesNotes.transactionNo }}
                                    </td>
                                    <td style="width: 150px">
                                        <span class="p-column-title">{{ l('PDate') }}</span>

                                        <span *ngIf="record.salesNotes.transactionDate">
                                            {{ record.salesNotes.transactionDate | luxonFormat: "dd-LLL-yyyy" }}
                                        </span>
                                        <span *ngIf="!record.salesNotes.transactionDate">-</span>
                                    </td>
                                    <td style="width: 150px">
                                        <span class="p-column-title">{{l('{{Property_Name_Here}}')}}</span>
                                        {{ record.salesNotes.vendorName }}
                                    </td>
                                    <td style="width: 150px">
                                        <span class="p-column-title">{{ l('ReferenceNo') }}</span>
                                        {{ record.salesNotes.referenceNo }}
                                    </td>
                                    <td style="width: 150px" class="text-end">
                                        <span class="p-column-title">{{ l('subTotal') }}</span>
                                        {{ record.salesNotes.subTotal | priceFormat }}
                                    </td>
                                    <td style="width: 150px" class="text-end">
                                        <span class="p-column-title">{{ l('Tax') }}</span>
                                        {{ record.salesNotes.tax | priceFormat }}
                                    </td>
                                    <td style="width: 150px" class="text-end">
                                        <span class="p-column-title">{{ l('NetTotal') }}</span>
                                        {{ record.salesNotes.netTotal | priceFormat }}
                                    </td>
                                   
                                    <td style="width: 150px" class="text-center">
                                        <span class="p-column-title">{{ l('Status') }}</span>
                                        <span class="badge" [ngClass]="utilsService.getStatusBadgeClass(record.salesNotes.status)">
                                            {{ l(status[record.salesNotes.status]) }}
                                        </span>
                                    </td>
                                    <td style="width: 150px" class="text-center" *ngIf="this.type != 3">
                                        <span class="p-column-title">{{ l('PaymentStatus') }}</span>
                                        <span class="badge" [ngClass]="utilsService.getPaymentStatusBadgeClass(record.salesNotes.paymentStatus)">
                                            {{ l(paymentStatus[record.salesNotes.paymentStatus]) }}
                                        </span>
                                    </td>
                                   
                                </tr>
                            </ng-template>
                        </p-table>

                        <div class="primeng-no-data" *ngIf="primengTableHelper.totalRecordsCount == 0">
                            {{ l('NoData') }}
                        </div>

                        <div class="primeng-paging-container">
                            <p-paginator [rows]="primengTableHelper.defaultRecordsCountPerPage" #paginator
                                (onPageChange)="getSalesNotes($event)"
                                [totalRecords]="primengTableHelper.totalRecordsCount"
                                [rowsPerPageOptions]="primengTableHelper.predefinedRecordsCountPerPage"
                                [showCurrentPageReport]="true" [currentPageReportTemplate]="
                                    'TotalRecordsCount' | localize: primengTableHelper.totalRecordsCount
                                "></p-paginator>
                        </div>
                    </div>
                    <!--<Primeng-Datatable-End>-->
                </div>
            </div>
        </div>
    </div>
</div>
